import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerPWA, onUpdateReady, applyUpdate } from "@/lib/pwa";
import { toast } from "sonner";

window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
  }
});

registerPWA();

// Toast users when a new app version is ready — one tap to apply.
onUpdateReady((registration) => {
  toast('Update available', {
    description: 'A new version of Elara is ready.',
    duration: 15000,
    action: {
      label: 'Reload',
      onClick: () => applyUpdate(registration),
    },
  });
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
